export * from './post-kunde.component';
export * from './post-kunde.component.module';